<p-sidebar [(visible)]="visibleDriversFilter"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'540px'}">
    <ng-template pTemplate="header">
        <div class="driver-filter-header">
            Filter
        </div>
    </ng-template>
    <div>
        <p-toast></p-toast>

        <p-scrollPanel [style]="{height: 'calc(100vh - 190px)'}">

            <ng-container *ngIf="appData?.isBoracayLocation">
                <div class="driver-filter-title">
                    Service
                </div>
                <div class="flex flex-row" style="flex-wrap: wrap;">
                <span class="driver-filter-total-spend"
                      [class]="(!filterObj.serviceType) ? 'driver-filter-total-spend__active' : ''"
                      (click)="filterObj.serviceType = null; filterObj.vehicleType = null">All</span>
                    <span class="driver-filter-total-spend"
                          [class]="(filterObj.serviceType === serviceType.Single) ? 'driver-filter-total-spend__active' : ''"
                          (click)="filterObj.serviceType = serviceType.Single">Ride - Single</span>
                    <span class="driver-filter-total-spend"
                          [class]="(filterObj.serviceType === serviceType.Ride && filterObj.vehicleType === vehicleType.Van) ? 'driver-filter-total-spend__active' : ''"
                          (click)="filterObj.serviceType = serviceType.Ride; filterObj.vehicleType = vehicleType.Van">Ride - Van</span>
                    <span class="driver-filter-total-spend"
                          [class]="(filterObj.serviceType === serviceType.Ride && filterObj.vehicleType === vehicleType.Multicab) ? 'driver-filter-total-spend__active' : ''"
                          (click)="filterObj.serviceType = serviceType.Ride; filterObj.vehicleType = vehicleType.Multicab">Ride - Multicab</span>
                    <span class="driver-filter-total-spend"
                          [class]="(filterObj.serviceType === serviceType.Ride && filterObj.vehicleType === vehicleType.Minibus) ? 'driver-filter-total-spend__active' : ''"
                          (click)="filterObj.serviceType = serviceType.Ride; filterObj.vehicleType = vehicleType.Minibus">Ride - Bus</span>
                </div>
            </ng-container>

            <div class="driver-filter-title">
                Signup Date
            </div>
            <div class="flex flex-row">
                <div class="w-15rem">
                    <p-calendar [(ngModel)]="filterObj.signupDate" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Please Select"
                                [showIcon]="true"></p-calendar>
                </div>
            </div>
        </p-scrollPanel>

        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button class="outlined-white-btn" pButton label="Clear" (click)="clear()"></button>
            <button class="btn-darkblue ml-3" pButton label="Apply" (click)="clickFilter()"></button>
        </div>
    </div>
</p-sidebar>